export default function search(){
    let desktopSearch = document.getElementById("searchInput");
    let desktopSearchContainer = document.querySelector(".search-container");
    let page = document.querySelector(".page-wrapper.content-wrapper");
    let footer = document.querySelector(".page-wrapper.footer-wrapper");

    const removeFocusInput = () => {
        if (desktopSearch.classList.contains("active")) {
            desktopSearch.classList.remove("active");
            desktopSearchContainer.classList.remove("active");
            desktopSearch.blur();
        }
    };

    if(desktopSearch){
        desktopSearch.addEventListener("click", () => {
            desktopSearch.classList.toggle("active");
            desktopSearchContainer.classList.toggle("active");

            if (!desktopSearch.classList.contains("active")) {
                desktopSearch.blur();
            }
        });

        page.addEventListener("click", removeFocusInput);
        footer.addEventListener("click", removeFocusInput);
    }
}
